import { Languages } from 'types';

export interface LangItems {
  [langName: string]: string;
}

export interface LangConfig {
  default: Languages;
  items: LangItems;
}

const langConfig: LangConfig = {
  default: Languages.EnUs,
  items: {
    [Languages.EnUs]: 'English',
  },
};

export default langConfig;
